// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.pane_r0x40 {
  position : relative;
  background: transparent;
  padding : 0px;
  border : none;
}

.pane_r0x40.pane-smallPadding_LWGCN {
  padding : 4px;
}

.pane_r0x40.pane-medPadding_tAM4N{
  padding : 8px;
}

.pane_r0x40.pane-largePadding_gyf4T {
  padding : 16px;
}

`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Pane.css"],"names":[],"mappings":";;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["\n\n.pane {\n  position : relative;\n  background: transparent;\n  padding : 0px;\n  border : none;\n}\n\n.pane.pane-smallPadding {\n  padding : 4px;\n}\n\n.pane.pane-medPadding{\n  padding : 8px;\n}\n\n.pane.pane-largePadding {\n  padding : 16px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_r0x40`,
	"pane-smallPadding": `pane-smallPadding_LWGCN`,
	"pane-medPadding": `pane-medPadding_tAM4N`,
	"pane-largePadding": `pane-largePadding_gyf4T`
};
export default ___CSS_LOADER_EXPORT___;
